<template>
  <split-pane :min-percent="20" :default-percent="50" split="vertical">
    <template slot="paneL">
      <a-card title="提醒列表">
        <!--        <a slot="extra">-->
        <!--          <a-tooltip title="提醒逻辑：本期平均值 低于 往期平均值 * ( 1 - 阈值% )。时间跨度须以周为单位，周一开始，周日结束。">-->
        <!--            <a-icon type="info-circle" style="cursor: pointer;"/>-->
        <!--          </a-tooltip>-->
        <!--        </a>-->

        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="8" v-if="userInfo().username !== 'admin'">
                <a-form-item label="关爱等级">
                  <j-dict-select-tag
                    v-model="queryParam.threshold"
                    placeholder="请选择关爱等级"
                    dictCode="warn_level"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8" v-else>
                <a-form-item label="情绪阈值">
                  <a-input-number v-model="queryParam.threshold" :min="0" :max="100" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="时间范围">
                  <a-range-picker :value="rangeDate" @change="onRangeChange" />
                </a-form-item>
              </a-col>

              <a-col :span="4">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="loadData" icon="search">查询</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ y: 650 }"
            bordered
            rowKey="id"
            :columns="columnsWithOutHidden"
            :dataSource="dataSource"
            :loading="loading"
            :pagination="false"
            class="j-table-force-nowrap"
          >
            <a
              slot="className"
              :style="text === currentClassName ? 'color:red' : ''"
              slot-scope="text, record"
              @click="changeSelect(record)"
            >
              {{ text }}
            </a>
          </a-table>
        </div>
      </a-card>
    </template>
    <template slot="paneR">
      <a-card title="分析模型">
        <a-spin tip="加载中..." :spinning="chartLoading">
          <smooth-line-chart-multid
            :height="187"
            :title="currentClassName + '【本期与往期情绪趋势】'"
            :fields="['本期', '往期']"
            :dataSource="selfData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentClassName + '【本期与年级情绪趋势】'"
            :fields="['本班', '年级']"
            :dataSource="gradeData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentClassName + '【近8周提醒人数】'"
            :fields="['提醒趋势']"
            :dataSource="warnData"
          />
        </a-spin>
      </a-card>
    </template>
  </split-pane>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import splitPane from 'vue-splitpane'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'ClassWarn',
  mixins: [JeecgListMixin],
  components: {
    splitPane,
    SmoothLineChartMultid,
  },
  data() {
    return {
      loading: false,
      queryParam: {
        threshold: 20,
      },
      //分析模型
      chartLoading: false,
      selfData: [],
      gradeData: [],
      warnData: [],
      //查询数据范围
      rangeDate: [],
      //当前选中的班级
      currentClassId: '',
      currentClassName: '',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          scopedSlots: { customRender: 'className' },
        },
        {
          title: '年级',
          align: 'center',
          dataIndex: 'gradeName',
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '班级(本期)',
              align: 'center',
              dataIndex: 'classHappyRate',
            },
            {
              title: '班级(往期)',
              align: 'center',
              dataIndex: 'historyHappyRate',
            },
            {
              title: '年级(本期)',
              align: 'center',
              dataIndex: 'gradeHappyRate',
            },
          ],
        },
      ],
      columnsWithOutHidden: [],
      url: {
        list: '/statistic/classWarn',
        classWarnAnalysis: '/statistic/classWarnAnalysis',
      },
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.loadData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    loadData() {
      this.loading = true
      getAction(this.url.list, this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result
        }
        if (res.code === 500) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    changeSelect(record) {
      this.currentClassId = record.classId
      this.currentClassName = record.className
      this.loadChartData(record.classId)
    },
    loadChartData(classId) {
      this.chartLoading = true
      this.queryParam.classId = classId
      getAction(this.url.classWarnAnalysis, this.queryParam).then((res) => {
        if (res.success) {
          this.selfData = res.result.warnSchoolClassBySelfList
          this.gradeData = res.result.warnSchoolClassByGradeList
          this.warnData = res.result.warnTrend
        }
        this.chartLoading = false
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
